import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { BookOpen } from 'lucide-react';
import { readerSrc, type MagazineIssue } from '@/lib/rothusMagazines';

interface MagazineReaderDialogProps {
  issue: MagazineIssue | null;
  onClose: () => void;
}

const MagazineReaderDialog: React.FC<MagazineReaderDialogProps> = ({ issue, onClose }) => {
  return (
    <Dialog open={!!issue} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-5xl p-4">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-primary" />
            {issue ? (
              <>glide N° {issue.issue_number} – Leseprobe</>
            ) : (
              <>Leseprobe</>
            )}
          </DialogTitle>
        </DialogHeader>
        {issue && (
          <iframe
            src={readerSrc(issue)}
            style={{ width: '100%', height: '80vh', border: 0 }}
            allowFullScreen
            loading="lazy"
            title={`glide N° ${issue.issue_number}`}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MagazineReaderDialog;
